import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SignAction } from '../../../redux/actions/user';
import { USER_SIGNIN_RESET } from '../../../redux/constantes/user';

import ContainerLogin from '../../../components/Login/ContainerLogin';
import LogoLogin from '../../../components/Login/LogoLogin';
import FooterLogin from '../../../components/Login/FooterLogin';
import WrapperButton from '../../../components/Login/WrapperButton';
import InputLogin from '../../../components/Login/InputLogin';
import ButtonLogin from '../../../components/Login/ButtonLogin';
import { MessageErrorLogin, MessageAlertLogin } from '../../../components/Login/MessagesLogin';
import ButtonRedirect from '../../../components/Login/ButtonRedirect';
import MainLogin from '../../../components/Login/MainLogin';
import MessageNewSystem from '../../../components/Login/MessageNewSystem';

export default function TemplateLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [expiredPassword, setExpiredPassword] = useState(false);

  const { error: errorUserSign, loading: loadingUserSign } = useSelector((state) => state.userSign);
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    if (email === 'integracao@spa-br.com') {
      setExpiredPassword(true);
      return;
    }
    dispatch(SignAction(email, password));
  };

  useEffect(() => {
    if (errorUserSign) {
      setTimeout(() => {
        dispatch({ type: USER_SIGNIN_RESET });
      }, 3000);
    }
    if (expiredPassword) {
      setTimeout(() => {
        setExpiredPassword(false);
      }, 4000);
    }
  }, [dispatch, errorUserSign, expiredPassword]);

  return (
    <ContainerLogin>
      <MainLogin>
        <MessageNewSystem />
        <LogoLogin />
        <InputLogin
          pathIcon="/images/icons/user.svg"
          name="Login"
          type="email"
          placeholder="exemplo@email.com"
          onInputChange={(v) => setEmail(v)}
          value={email}
        />
        <InputLogin
          pathIcon="/images/icons/password.svg"
          name="Senha"
          type="password"
          onInputChange={(v) => setPassword(v)}
          value={password}
        />
        {errorUserSign && <MessageErrorLogin>{errorUserSign}</MessageErrorLogin>}
        {expiredPassword && (
          <MessageAlertLogin>Sua senha está expirada! Entre em contato com o suporte.</MessageAlertLogin>
        )}
        <WrapperButton>
          <ButtonRedirect href="/recuperar-senha">Esqueci minha senha</ButtonRedirect>
          <ButtonLogin name="entrar" onClick={handleSubmit} disabled={loadingUserSign}>
            {loadingUserSign ? 'Aguarde...' : 'Entrar'}
          </ButtonLogin>
        </WrapperButton>
      </MainLogin>
      <FooterLogin />
    </ContainerLogin>
  );
}
